var React = require('react');

function IconmonstrArrow24 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z"}));
}

IconmonstrArrow24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconmonstrArrow24;

IconmonstrArrow24.default = IconmonstrArrow24;
